import React, { useMemo, useState } from 'react';
import '../styles/Events.css';

const photoPlaceholders = [
  { id: 1, src: '/images/events/LSI_Pictures/LSI-Josh and Michael.jpg' },
  { id: 2, src: '/images/events/LSI_Pictures/LSI_Umbrella_sunset.jpg' },
  { id: 3, src: '/images/events/LSI_Pictures/LSI-FireSide Chat.jpg' },
  { id: 4, src: '/images/events/LSI_Pictures/LSI-Golf_Sunset.jpg' },
  { id: 5, src: '/images/events/LSI_Pictures/LSI-Dinner.jpg' },
  { id: 6, src: '/images/events/LSI_Pictures/LSI-Walking_Path.jpg' },
  {
    id: 7,
    src: '/images/events/LSI_Pictures/LSI_JoshsCam_Michael_Presenting.jpg',
  },
  {
    id: 8,
    src: '/images/events/LSI_Pictures/LSI_JoshsCam_Michael_Presenting2.jpg',
  },
  { id: 9, src: '/images/events/LSI_Pictures/LSI_On_Stage_Short.jpg' },
  {
    id: 10,
    src: '/images/events/LSI_Pictures/LSI-Evening Feet-up at Sunset - Tuesday.jpg',
  },
];

export default function LSI_US_2026() {
  const [hoverPreview, setHoverPreview] = useState(null);
  const [mobilePreview, setMobilePreview] = useState(null);

  const isTouchDevice = useMemo(() => {
    if (typeof window === 'undefined') return false;
    return (
      'ontouchstart' in window ||
      (navigator && navigator.maxTouchPoints > 0) ||
      window.matchMedia?.('(hover: none)').matches
    );
  }, []);

  const openMobilePreview = (photo) => {
    setMobilePreview({
      src: photo.src,
      alt: `LSI photo ${photo.id}`,
    });
  };

  const closeMobilePreview = () => setMobilePreview(null);

  return (
    <div className="patent-page">
      <div className="patent-page__bg-orb patent-page__bg-orb--1" />
      <div className="patent-page__bg-orb patent-page__bg-orb--2" />

      {/* Desktop hover preview */}
      {hoverPreview && !isTouchDevice && (
        <div className="hover-zoom-overlay" aria-hidden="true">
          <div className="hover-zoom-overlay__backdrop" />
          <div className="hover-zoom-overlay__panel">
            <img
              className="hover-zoom-overlay__img"
              src={hoverPreview.src}
              alt={hoverPreview.alt}
            />
          </div>
        </div>
      )}

      {/* Mobile preview */}
      {mobilePreview && (
        <div
          className="mobile-image-modal"
          role="dialog"
          aria-modal="true"
          aria-label="Image preview"
          onClick={closeMobilePreview}
        >
          <div className="mobile-image-modal__backdrop" />
          <div
            className="mobile-image-modal__frame"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              className="mobile-image-modal__close"
              onClick={closeMobilePreview}
              aria-label="Close image preview"
            >
              ✕
            </button>
            <img
              className="mobile-image-modal__img"
              src={mobilePreview.src}
              alt={mobilePreview.alt}
            />
          </div>
        </div>
      )}

      <header className="patent-hero">
        <h1 className="patent-hero__title">LSI USA Summit 2026</h1>
        <p className="patent-hero__subtitle">
          Moments from LSI USA Summit in Dana Point — connecting with investors,
          presenting SleepDev, and engaging with the medtech community.
        </p>
      </header>

      <section className="gallery-section" aria-label="LSI photo gallery">
        <div className="photo-grid">
          {photoPlaceholders.map((photo) => {
            return (
              <figure key={photo.id} className="photo-card">
                <div className="photo-card__frame">
                  <img
                    className="photo-card__image"
                    src={photo.src}
                    alt={`LSI photo ${photo.id}`}
                    onMouseEnter={() => {
                      if (isTouchDevice) return;
                      setHoverPreview({
                        src: photo.src,
                        alt: `LSI photo ${photo.id}`,
                      });
                    }}
                    onMouseLeave={() => {
                      if (isTouchDevice) return;
                      setHoverPreview(null);
                    }}
                    onClick={() => {
                      if (isTouchDevice) openMobilePreview(photo);
                    }}
                  />
                </div>
              </figure>
            );
          })}
        </div>
      </section>

      <footer className="patent-footer">
        <div className="patent-footer__line" />
        <p>SleepDev • LSI USA Summit 2026 • Photo Gallery</p>
      </footer>
    </div>
  );
}
